<template>
  <div class="navMobileList" :class="{ expand: displayAccSwapper }">
    <directional_swipe :direction="transition_direction">
      <account_swapper
        v-if="displayAccSwapper"
        key="accSwap"
        class="accSwap heightControl"
        @close="displayAccSwapper = false"
      />
      <div v-else class="list">
        <profile_infos
          v-if="entity"
          class="margedUp"
          :kind="kind"
          :entity="entity"
          @close="$emit('close')"
        />
        <nuxt-link
          v-if="is_band"
          class="text marginTop"
          to="/"
          @click.native="$emit('close')"
        >
          {{ $t("layout.navigation00") }}
        </nuxt-link>
        <nuxt-link
          v-else-if="is_inf"
          class="text marginTop"
          to="/influencer/list/all/"
          @click.native="$emit('close')"
        >
          {{ $t("layout.navigation12") }}
        </nuxt-link>
        <nuxt-link
          v-if="is_band"
          class="text"
          to="/band/draft/"
          @click.native="$emit('close')"
        >
          {{ $t("layout.navigation11") }}
        </nuxt-link>
        <nav_mobile_list_band v-if="is_band" @close="$emit('close')" />
        <nav_mobile_list_influencer v-if="is_inf" @close="$emit('close')" />
        <nuxt-link class="text" to="/parameter/" @click.native="$emit('close')">
          {{ $t("layout.menu.menu02") }}
        </nuxt-link>
        <a
          :href="`https://help.groover.co/${lang}/`"
          class="text"
          @click="$emit('close')"
          >{{ $t("layout.menu.menu03") }}</a
        >
        <div
          v-if="accounts.length"
          class="text flex"
          @click.stop="displayAccSwapper = true"
        >
          <span class="otherText">{{ $t("layout.menu.menu04") }}</span>
          <i class="fas fa-chevron-right" />
        </div>
        <div v-else class="text flex" @click="login_request_account_swap">
          <span class="otherText">{{ $t("auth.accountSwitch00") }}</span>
        </div>
        <div class="text logout" @click="logout">
          {{ $t("layout.menu.menu05") }}
        </div>
      </div>
    </directional_swipe>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex"

import nav_mobile_list_band from "~/components/nav/mobile/list/band"
import nav_mobile_list_influencer from "~/components/nav/mobile/list/influencer"
import profile_infos from "~/components/nav/loggedIn/contextMenu/profileInfos"

import cache_mixin from "~/mixins/cache"
import acc_swapper_mixin from "~/mixins/nav/accSwapper"

export default {
  components: {
    profile_infos,
    nav_mobile_list_band,
    nav_mobile_list_influencer,
  },
  mixins: [cache_mixin, acc_swapper_mixin],
  computed: {
    ...mapState({
      lang: (state) => state.user.lang,
      inf: (state) => state.user.influencer,
      accounts: (state) => state.accounts,
    }),
    ...mapGetters({
      kind: "user/KIND",
      is_inf: "user/IS_INF",
      is_band: "user/IS_BAND",
      band: "user/band/BAND_DATA",
    }),
    entity: function () {
      if (this.is_band) return this.band
      if (this.is_inf) return this.inf
    },
  },
  methods: {
    logout: function () {
      if (this.is_band) this.SET_LOGIN_OUT()
      this.cleanCacheAll()
      this.store_logout()
    },
    ...mapActions({
      store_logout: "user/LOGOUT",
    }),
    ...mapMutations({
      SET_LOGIN_OUT: "misc/draft/SET_LOGIN_OUT",
    }),
  },
}
</script>

<style scoped src="./list.css"></style>
<style scoped src="./list/shared.css"></style>
